import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, EMPTY } from 'rxjs';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

@Injectable()
export class ExternalService {

  private liqInfo: Observable<any[]> = EMPTY;
  constructor(private _http: HttpClient) {}

  // función para buscar información acerca de la liquidación del back
  getLiquidation(nLiquidation, operation): Observable<any[]> {
     operation = isNullOrUndefined(operation) ? 0 : operation;
     this.liqInfo = this._http.get<any[]>(`${environment.BACKEND}externalSource/liquidacionExt/${operation}/${nLiquidation}`);
    return this.liqInfo;
  }

  // función para buscar información acerca de la liquidación del back
  datosLiqConBaja(values): Observable<any[]> {
    const httpParams = new HttpParams({
      fromObject: values
    });
    this.liqInfo = this._http.get<any[]>(`${environment.BACKEND}externalSource/datosLiqConBaja`, {
      params: httpParams
    });
    return this.liqInfo;
  }

  // función para traer info de la liquidación a un componente sin volver a solicitarla del back
  rememberLiqInfo(liquidacion, operacion) {
    if (this.liqInfo === EMPTY) {
      this.liqInfo = this.getLiquidation(liquidacion, operacion);
    }
    return this.liqInfo;
  }
}
